"use client";

import { cn } from "@/lib/utils";
import { useEffect, useRef, useState } from "react";
import dynamic from "next/dynamic";
import { isMobile } from "react-device-detect";

const SocialShare = dynamic(() => import("./socialShare"), { ssr: false });

const LayoutDetail = ({ children }) => {
  const [isSectionFixed, setIsSectionFixed] = useState(false);
  const tocRef = useRef(null);

  // Scroll detection for fixing section
  useEffect(() => {
    const customBottom = 120;
    const handleScroll = () => {
      if (!tocRef.current) return;
      const rect = tocRef.current.getBoundingClientRect();
      if (rect.top <= 100 && rect.bottom > customBottom) {
        setIsSectionFixed(true);
      } else {
        setIsSectionFixed(false);
      }
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="max-w-[1440px] mx-auto relative min-h-screen ">
      {/* <div
        className={cn(
          " absolute lg:right-[73px] lg:top-[100px] z-[99]",
          isSectionFixed && "fixed  top-[100px]",
        )}
        style={{ right: isMobile ? "20px" : "calc(50% - 720px + 73px)" }}
      >
        <SocialShare />
      </div> */}
      <div
        ref={tocRef}
        className=" px-5 pt-10 pb-[69px] lg:px-[40px] lg:pt-[37px] lg:pb-[138px] relative"
      >
        {children}
      </div>
    </div>
  );
};

export default LayoutDetail;
